/*
 * @Descripttion: 表单管理-新建表单
 * @Date: 2024-12-25 15:03:05
 */
import { route } from './src/router';

const name = 'formAdd';
export { name, route };
